import Cookies from 'js-cookie';
import { getOptionFunc } from '../state';
export const processAppSwitcherHeaders = (options, headers) => {
    const getOption = getOptionFunc(options);
    const appSwitcherAuthUserFromCookie = Cookies.get('appSwitcherAuthUser');
    const appSwitcherUserRoleFromCookie = Cookies.get('appSwitcherUserRole');
    // JSESSSIONID
    // @ts-expect-error - non-standard ie property check below
    const browserLocale = navigator.language ?? navigator?.userLanguage;
    const locale = getOption('locale') ?? browserLocale;
    return {
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            ...(appSwitcherAuthUserFromCookie ? { 'x-medallia-app-switcher-user': appSwitcherAuthUserFromCookie } : {}),
            ...(appSwitcherUserRoleFromCookie ? { 'x-medallia-app-switcher-role': appSwitcherUserRoleFromCookie } : {}),
            'x-medallia-app-switcher-locale': locale
        }
    };
};
